import { Stack, TableCell, Typography } from '@mui/material'
import { t } from 'i18next'
import { useNavigate } from 'react-router-dom'
import AvatarComponent from '../../components/avatar/AvatarComponent'
import UsersMenuPopup from '../../components/Popup/UsersMenuPopup'
import { StickyCell } from '../../styles/WorklogTableStyles'
import navigation from '../../config/navigation'
import { useSelector } from 'react-redux'
import { getCurrentUser } from '../../store/redux/reducers/currentUserSlice'
import { Row } from '../../store/types/utils/DataTableUtils'
import { extractUserData } from '../../store/utils/usersUtils'
import { useMemo } from 'react'

interface UserTableRowProps {
  user: Row
}

const UserTableRow = ({ user }: UserTableRowProps) => {
  const navigate = useNavigate()
  const currentUser = useSelector(getCurrentUser)
  const navigateString = currentUser?.id !== user.id ? `${navigation.users}/${user.id}` : `${navigation.myProfile}`
  const userData = extractUserData(user)

  const leaders = useMemo(() => {
    return user.leaders && user.leaders.length > 0
      ? user.leaders
          .map((leader: { firstName: string; lastName: string }) => `${leader.firstName} ${leader.lastName}`)
          .join(', ')
      : '-'
  }, [user.leaders])

  return (
    <>
      <TableCell
        sx={{ overflow: 'hidden', width: { lgUp: 300, lgDown: 100 }, maxWidth: 300, minWidth: 100 }}
        onClick={() => navigate(navigateString)}
      >
        <Stack direction="row" gap={3} alignItems="center">
          <AvatarComponent
            extension={userData.extension}
            avatar={userData.avatar}
            alt={`${user.firstName}-${user.lastName}-profile-picture`}
            size={32}
          />
          <Stack
            sx={{
              overflow: 'hidden',
              whiteSpace: 'nowrap',
              textOverflow: 'ellipsis',
              width: { xl: 300, lg: 250, md: 150, sm: 100, xs: 50 },
              maxWidth: 300,
              minWidth: 100,
            }}
            direction="column"
          >
            <Typography variant="body1" fontWeight={500}>
              {user.firstName}
            </Typography>
            <Typography variant="body2" color="text.dark">
              {user.lastName}
            </Typography>
          </Stack>
        </Stack>
      </TableCell>
      <TableCell onClick={() => navigate(navigateString)}>{user.email}</TableCell>
      <TableCell onClick={() => navigate(navigateString)}>{user.phoneNumber ?? '-'}</TableCell>
      <TableCell onClick={() => navigate(navigateString)}>{leaders}</TableCell>
      <TableCell onClick={() => navigate(navigateString)} align="left">
        {t(`statuses.${user.employeeStatus.toLowerCase()}`)}
      </TableCell>
      <StickyCell
        align="center"
        sx={{
          borderLeft: '2px solid',
          borderLeftColor: 'background.elevation8',
          right: 0,
          '&:hover': { cursor: 'auto' },
        }}
      >
        <UsersMenuPopup user={userData} navigateString={navigateString} />
      </StickyCell>
    </>
  )
}

export default UserTableRow
